import IRA from "./ira.json";
import moneyFormatter from "../../common/moneyFormatter";

const DecumulationHelper = {
  Data: props => {
    const {
      savings,
      withdraw,
      dec_socialSecurity,
      dec_otherIncome,
      dec_investmentSource,
      retirementAccount,
      age,
      rate
    } = props;
console.log(props, "--props from -rig eq helper--")
    let currentSavings = savings;

    let newData = [];
    let lineChartData = [];
    let dec_BarChartData = [];
    let dec_pdfTable = [];

    let year = new Date().getFullYear();

    // social security, other income, investment source
    var SC = dec_socialSecurity;
    var OI = dec_otherIncome;
    var IS = dec_investmentSource;

    // IRA calc
    var RetiremenSavings = retirementAccount;

    for (let i = 0; i <= 20; i++) {
      let obj = {};
      let lineChart = {};
      let decBarChart = {};

      let pdfTable = [];

      IS = currentSavings * (rate / 100);
      IS = IS < 0 ? 0 : IS;

      // IRA
      let RetireAge = age + i;

      var retireIRA = 0;
      if (RetireAge >= 70) {
        console.log(IRA[RetireAge]);
        retireIRA = RetiremenSavings / IRA[RetireAge];
        console.log(RetiremenSavings);
        RetiremenSavings = RetiremenSavings - retireIRA;
      }
      // *****

      var shortFall = +(withdraw - (SC + OI + IS) - retireIRA).toFixed() * 1;
      if (shortFall < 0) {
        shortFall = 0;
      }

      obj["year"] = (year * 1 + i).toString();
      obj["Social Security"] = dec_socialSecurity;
      obj["IRA"] = retireIRA.toFixed() * 1;
      obj["Investment Source"] = IS.toFixed(2) * 1;
      obj["Other Income"] = dec_otherIncome;
      var originalShortFall = shortFall;
      if (currentSavings < shortFall) {
        shortFall = currentSavings;
      }
      obj["Withdraw from Savings"] = shortFall; //(shortFall > withdraw || currentSavings <= 0 ) ? 0 : shortFall;
      obj["Shortfall"] =
        currentSavings < originalShortFall
          ? (originalShortFall - currentSavings).toFixed()
          : 0;

      // decumulation pdf table data
      pdfTable.push(
        obj["year"],
        moneyFormatter(obj["Social Security"], false),
        moneyFormatter(obj["IRA"], false),
        moneyFormatter(obj["Investment Source"], false),
        moneyFormatter(obj["Other Income"], false),
        moneyFormatter(obj["Withdraw from Savings"], false),
        moneyFormatter(obj["Shortfall"], false),
        moneyFormatter(currentSavings * 1, false)
      );
      // line chart data
      lineChart["Year"] = (year * 1 + i).toString() * 1;
      lineChart["Savings"] = currentSavings * 1;

      // solution decumulation bar chart
      decBarChart["metric_name"] = (year * 1 + 21 + i).toString() * 1;
      decBarChart["Savings"] = currentSavings * 1;
      SC = dec_socialSecurity;
      OI = dec_otherIncome;
      // subtract short fall from savings
      currentSavings = +(currentSavings - shortFall).toFixed(2);
      if (currentSavings < 0) currentSavings = 0;

      newData.push(obj);
      lineChartData.push(lineChart);
      dec_BarChartData.push(decBarChart);
      dec_pdfTable.push(pdfTable);
    }

    return [newData, lineChartData, dec_BarChartData, dec_pdfTable];
  }
};

export default DecumulationHelper;



// WEBPACK FOOTER //
// ./src/components/pages/Retire/RIGEquation.helper.js